module.exports = __webpack_public_path__ + "img/logo_lhtj.ebda2b63.png";